/**
 * Adds a gif for a given participant.
 * {{
 *      type: ADD_GIF_FOR_PARTICIPANT,
 *      participantId: string,
 *      gifUrl: string,
 *      timeoutID: number
 * }}.
 */
export const ADD_GIF_FOR_PARTICIPANT = 'ADD_GIF_FOR_PARTICIPANT';

/**
 * Set timeout to hide a gif for a given participant.
 * {{
 *      type: HIDE_GIF_FOR_PARTICIPANT,
 *      participantId: string
 * }}.
 */
export const HIDE_GIF_FOR_PARTICIPANT = 'HIDE_GIF_FOR_PARTICIPANT';

/**
 * Removes a gif for a given participant.
 * {{
 *      type: REMOVE_GIF_FOR_PARTICIPANT,
 *      participantId: string
 * }}.
 */
export const REMOVE_GIF_FOR_PARTICIPANT = 'REMOVE_GIF_FOR_PARTICIPANT';

/**
 * Set gif menu visibility.
 * {{
 *      type: SET_GIF_MENU_VISIBILITY,
 *      visible: boolean
 * }}.
 */
export const SET_GIF_MENU_VISIBILITY = 'SET_GIF_MENU_VISIBILITY';

/**
 * Keep showing a gif for a given participant.
 * {{
 *      type: SHOW_GIF_FOR_PARTICIPANT,
 *      participantId: string
 * }}.
 */
export const SHOW_GIF_FOR_PARTICIPANT = 'SHOW_GIF_FOR_PARTICIPANT';

/**
 * Open GIF Modal.
 * {{
 *      type: OPEN_GIF_MODAL,
 *      isGifModalOpen: boolean
 * }}.
 */
export const OPEN_GIF_MODAL = 'OPEN_GIF_MODAL';

/**
 * Close GIF Modal.
 * {{
 *      type: CLOSE_GIF_MODAL,
 *      isGifModalOpen: boolean
 * }}.
 */
export const CLOSE_GIF_MODAL = 'CLOSE_GIF_MODAL';

export const GIF_MODAL_ID = 'gifModalView';
